import axiosInstance from '@/lib/axiosInstance';
import { supabase } from '@/lib/supabase';
import { TablesInsert, TablesUpdate } from '@/types/database.types';
import { AxiosPromise } from 'axios';
import { AuthTokenResponse } from './type';

export const getUser = async () => {
  const { data, error } = await supabase.from('user').select().single();
  if (error) throw error;
  if (!data) throw new Error('User not found');
  return data;
};

export const updateUser = async (userData: TablesUpdate<'user'>) => {
  const { email, ...params } = userData;
  const { data, error } = await supabase
    .from('user')
    .update(params)
    .eq('email', email || '')
    .single();
  if (error) throw error;
  return data;
};

export const createUser = async (userData: TablesInsert<'user'>) => {
  const { data, error } = await supabase.from('user').insert(userData);
  if (error) throw error;
  return data;
};

export const deleteUser = async (userData: TablesInsert<'user'>) => {
  const { data, error } = await supabase.from('user').insert(userData);
  if (error) throw error;
  return data;
};

export const getAuthToken = async () => {
  const { data } = await axiosInstance.post<AuthTokenResponse, AxiosPromise<AuthTokenResponse>>(
    '/mock'
  );
  return data;
};

export const regenAuthToken = async () => {
  const { data } = await axiosInstance.post<AuthTokenResponse, AxiosPromise<AuthTokenResponse>>(
    '/mock'
  );
  return data;
};
